// @flow
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import style from './WeAre.scss';

type Props = {};

type State = {
  messageIntlIndex: number;
};

const wordsIntl = [
  'aboutUs.weAre.united',
  'aboutUs.weAre.innovatives',
  'aboutUs.weAre.fearless',
];

const INTERVAL_TIME = 2000;

export default class WeAre extends Component<Props, State> {
  intervalID: IntervalID;
  state = {
    messageIntlIndex: 0,
  };

  componentDidMount() {
    this.intervalID = setInterval(() => this.setState((state: State) => ({
      messageIntlIndex: (state.messageIntlIndex + 1) % wordsIntl.length,
    })), INTERVAL_TIME);
  }

  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  render() {
    const { messageIntlIndex } = this.state;
    return (
      <FormattedMessage id={wordsIntl[messageIntlIndex]}>{
        txt => <span className={style.messageWrap}>{txt}</span>
      }</FormattedMessage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/about-us/components/WeAre/WeAre.jsx